/**
 * @file CatalogSlotsLine.tsx
 * @description «Блоков над списком: N · под списком: M — [Изменить ›]» в
 * панели «Каталог» (phase19.16 Р2а; uiux-design-r2a §2; контракт §16.5
 * `GET /admin/site/slots`). Ссылка открывает экран «Каталог» — там блоки
 * мест правятся, как блоки страницы. Без права на контент строки нет.
 */

import { useEffect, useState } from "react";
import { Link } from "react-router";

import { useHasPermission } from "../../../auth/hooks";
import { useBuilderLink } from "../../../hooks/site-builder/useBuilderLink";
import { sitePages, type SiteSlotItem } from "../../../lib/api-site-pages";

export function CatalogSlotsLine() {
  const canEdit = useHasPermission("SHOP_MANAGE_CONTENT");
  const link = useBuilderLink();
  const [slots, setSlots] = useState<SiteSlotItem[] | null>(null);
  useEffect(() => {
    if (!canEdit) return;
    let alive = true;
    sitePages
      .slots()
      .then((list) => alive && setSlots(list))
      .catch(() => alive && setSlots(null));
    return () => {
      alive = false;
    };
  }, [canEdit]);
  if (!canEdit) return null;
  const count = (key: SiteSlotItem["slot"]) => slots?.find((s) => s.slot === key)?.blocksCount ?? 0;
  return (
    <p className="type-caption flex flex-wrap items-center gap-x-2 rounded-lg bg-surface-low px-3 py-2 text-on-surface-variant">
      {slots ? `Блоков над списком: ${count("CATALOG_ABOVE")} · под списком: ${count("CATALOG_BELOW")}` : "Блоки над и под списком"}
      <Link to={link({ pageId: null, screen: "catalog", panel: null })} className="min-h-12 content-center font-medium text-primary hover:underline">
        Изменить ›
      </Link>
    </p>
  );
}
